/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Everything runs in your browser and your data never leaves your device.`)
};

const es_pie_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Todo se ejecuta en tu navegador y tus datos nunca salen de tu dispositivo.`)
};

const de_pie_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Alles läuft in Ihrem Browser, und Ihre Daten verlassen Ihr Gerät nie.`)
};

const nl_pie_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Alles draait in je browser en je data verlaat nooit je apparaat.`)
};

const fr_pie_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Tout s'exécute dans votre navigateur et vos données ne quittent jamais votre appareil.`)
};

const it_pie_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Tutto avviene nel tuo browser e i tuoi dati non lasciano mai il tuo dispositivo.`)
};

const pt_br2_pie_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Tudo é executado no seu navegador e seus dados nunca saem do seu dispositivo.`)
};

const pt_pie_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Tudo é executado no seu navegador e os seus dados nunca saem do seu dispositivo.`)
};

const ja_pie_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。すべてブラウザ内で処理され、データが端末から外部に送信されることはありません。`)
};

const zh_pie_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。所有操作都在你的浏览器中运行，你的数据不会离开你的设备。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_faq_a4", locale)
	if (locale === "en") return en_pie_faq_a4(inputs)
	if (locale === "es") return es_pie_faq_a4(inputs)
	if (locale === "de") return de_pie_faq_a4(inputs)
	if (locale === "nl") return nl_pie_faq_a4(inputs)
	if (locale === "fr") return fr_pie_faq_a4(inputs)
	if (locale === "it") return it_pie_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_pie_faq_a4(inputs)
	if (locale === "pt") return pt_pie_faq_a4(inputs)
	if (locale === "ja") return ja_pie_faq_a4(inputs)
	return zh_pie_faq_a4(inputs)
};